module.exports = __webpack_public_path__ + "img/1.68263e4f.png";